import { render, staticRenderFns } from "./PolicyEstatePlanning.vue?vue&type=template&id=37020034"
import script from "./PolicyEstatePlanning.vue?vue&type=script&lang=js"
export * from "./PolicyEstatePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports